import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Redirect } from "react-router-dom";

import * as AppUrls from "../../../constants/AppUrls";
import * as Helpers from "../../../global/Helpers";
import * as utils from "../../../global/utils";

import "react-toastify/dist/ReactToastify.css";

//loader
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { signal } from "@preact/signals-react";

import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import i18next from "i18next";
import { toast } from "react-toastify";
import "./OnboardingLogin.modules.css";

import NavbarOnboarding from "../NavbarOnboarding/NavbarOnboarding";
import KYCimg from "../../../assets/images/Sharjah/KYC.png";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import SessionExpiredPOPup from "../SessionExpiredPOPup/SessionExpiredPOPup";
import { groupIdSignal } from "../OnboardingHome/OnboardingHome";




toast.configure();
export const onboardingLookup = signal([]);

function OnboardingLogin() {
  const { t } = useTranslation();

  const [redirect, setRedirect] = useState(null);
  const [numberPrefix, setNumberPrefix] = useState("");
  const [countries, setCountries] = useState([]);
  const [ReqID, setReqID] = useState("");
  const [formData, setFormData] = useState({ email: "", mobile: "" });

  useEffect(() => {
    fetchCountries();
    GetDeviceConfigs();
    GetOnboardingLookUP();
  }, [i18next.language]);

  const handleChange = (e) => {
    var { name, value } = e.target;
    if (name === "mobile") {
      value = e.target.value.replace(/\D/, "");
    }
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateSubmit()) return;
    OTPSendKYC();
  };

  function validateSubmit() {
    if (formData.email === null || formData.email === "") {
      Helpers.errorNotify(t("emailisrequired"), i18next.language);
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // Validate email
    if (!emailRegex.test(formData.email)) {
      Helpers.errorNotify(t("validEmail"), i18next.language);
      return false;
    }

    if (formData.mobile === null || formData.mobile === "") {
      Helpers.errorNotify(t("mobileRequired"), i18next.language);

      return false;
    }
    if (numberPrefix === null || numberPrefix === "") {
      Helpers.errorNotify(t("mobileRequired"), i18next.language);
      return false;
    }

    return true;
  }

  let leftLocalized = "left";
  let mr2Localized = "mr-2";

  if (i18next.language === "ar") {
    leftLocalized = "right";
    mr2Localized = "ml-2";
  }
  const OTPSendKYC = async () => {
    try {
      const params = {
        Fname: formData.email,
        MobileNum: formData.mobile,
        Prefex: numberPrefix,
      };
      var response = utils.OTPSendKYC(params);
      await response
        .then((response) => {
          ;
          if (response.data.ErrorMsg.toUpperCase() === "SUCCESS") {
            setReqID(response.data.Request_Id);
            localStorage.setItem("RID", response.data.Request_Id);

            if (groupIdSignal) {
              if (groupIdSignal.value === "Personal") {
                Helpers.successNotify(t("tokenSent"), i18next.language);
                setRedirect(AppUrls.onboardingOTP);
              } else if (groupIdSignal.value === "Corporate") {
                Helpers.successNotify(t("tokenSent"), i18next.language);
                setRedirect(AppUrls.onboardingOTP);
              } else if (groupIdSignal.value === "Minor") {
                setRedirect(AppUrls.onboardingMinor);
              } else {
                      setRedirect(AppUrls.onboarding);
              }
            }

            // {"ErrorMsg":"Success","Request_Id":"13763","expires_in":464}
          }
          // else if (response.data.ErrorMsg === "Invalid token") {
          //   confirmAlert({
          //     customUI: ({ onClose }) => {
          //       return <SessionExpiredPOPup setRedirect={setRedirect} onClose={onClose} />;
          //     },
          //   });
          // }
          else {
            Helpers.errorNotify(response.data.ErrorMsg, i18next.language);
          }
        })
        .catch((error) => {
          console.log("OTPSendKYCAPI", error);
        });
    } catch (error) {
      console.log("OTPSendKYC", error);
    }
  };

  const fetchCountries = async () => {
    try {
      const params = {
        Lang: i18next.language === "ar" ? "AR" : "EN",
      };
      var response = utils.CountriesLookupAPI(params);
      await response
        .then((response) => {
          if (response.data.ErrorMsg === "success") {
            const sortedCountries = response.data.resData.sort((a, b) => {
              if (a.countryName < b.countryName) return -1;
              if (a.countryName > b.countryName) return 1;
              return 0;
            });
            setCountries(sortedCountries);
            const UAE = sortedCountries.find(
              (country) => country.PhoneCode.toUpperCase() === "+971"
            );
            if (UAE) {
              setNumberPrefix(UAE.PhoneCode.substring(1));
            } else if (sortedCountries.length > 0) {
              setNumberPrefix(sortedCountries[0].PhoneCode.substring(1));
            }
          }
          //else if (response.data.ErrorMsg === "Invalid token") {
          //   confirmAlert({
          //     customUI: ({ onClose }) => {
          //       return <SessionExpiredPOPup setRedirect={setRedirect} onClose={onClose} />;
          //     },
          //   });
          // }
          else {
            Helpers.errorNotify(response.data.ErrorMsg, i18next.language);
          }
        })
        .catch((error) => {
          console.log("fetchCountriesApi", error);
        });
    } catch (error) {
      console.log("fetchCountries", error);
    }
  };

  const GetOnboardingLookUP = async () => {
    try {
      var response = utils.GetOnboardingLookUP();
      await response
        .then((response) => {
          if (response?.data?.length > 0) {
            onboardingLookup.value = response.data;

          }
        })
        .catch((error) => {
          console.log("GetOnboardingLookUP", error);
        });
    } catch (error) {
      console.log("GetOnboardingLookUP", error);
    }
  };

  const GetDeviceConfigs = () => {
    let getProfilesByUserIdResponse = utils.GetDeviceConfigs();
    getProfilesByUserIdResponse
      .then((response) => response.data)
      .then((data) => {
        localStorage.setItem("DeviceConfigs", JSON.stringify(data));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  if (redirect !== null) {
    // return <Redirect to={redirect} />;
    return (
      <Redirect
        to={{
          pathname: redirect,
          state: { ReqID: ReqID },
        }}
      />
    );
  }

  return (
    <>
      <NavbarOnboarding  />

      <div className="login-main-container">
        <div className="KYCDivImg">
          <h2 className="OpenYourAccountwithUs">{t("OpenYourAccountwithUs")}</h2>
          <img className="KYCImg" src={KYCimg} />
        </div>
        <div className="login-container">
          <div className="login-form">
            <h2> {t("Getstartedbyentering")} </h2>

            <div className="form-group-OnboardingLogin">
              {/* <label className={formData.email ? "floating-label active" : "floating-label"} >{t("email")} </label>
              <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder={t("")} required />
               */}
              <label htmlFor="email">{t("email")}</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder={t("email")}
                required
              />
            </div>
            {/* <div className="form-group-OnboardingLogin">
                            <label htmlFor="mobile">{t("mobileNo")}</label>
                            <input
                                type="mobile"
                                id="mobile"
                                name="mobile"
                                value={formData.mobile}
                                onChange={handleChange}
                                placeholder={t("mobileNo")}
                                required
                            />
                        </div> */}
            <div className="form-group-OnboardingLogin">
              <label htmlFor="mobile">{t("mobileNo")}</label>
              <div className="input-group">
                <select
                  id="country"
                  value={numberPrefix}
                  onChange={(e) => setNumberPrefix(e.target.value)}
                  className="form-control"
                  style={{ width: "30%" }}
                >
                  {countries.map((country, index) => (
                    <option key={index} value={country.PhoneCode.substring(1)}>
                      {country.countryName + country.PhoneCode}
                    </option>
                  ))}
                </select>
                <input
                  type="text"
                  id="mobile"
                  name="mobile"
                  className="form-control"
                  value={formData.mobile}
                  onChange={handleChange}
                  maxLength={12}
                  placeholder={t("mobileNo")}
                  style={{ width: "70%" }}
                />
              </div>
            </div>
            <button
              type="submit"
              className="login-button"
              onClick={handleSubmit}
            >
              {t("Signup")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default OnboardingLogin;
